<template>
  <div
    class="flex flex-1 items-center justify-between gap-x-3 lg:justify-end lg:gap-x-6"
  >
    <div class="flex items-center gap-2">
      <button
        type="button"
        class="text-white lg:hidden"
        @click="$emit('openSidebar')"
      >
        <span class="sr-only">Open sidebar</span>
        <Bars3Icon class="size-6" aria-hidden="true" />
      </button>

      <NuxtLink to="/" class="hidden sm:block lg:hidden">
        <img
          class="float-right h-4 w-auto"
          src="/assets/icons/layout/logo-white.png"
          alt="Benchmark Mineral Intelligence"
        />
      </NuxtLink>
    </div>

    <div class="block w-auto sm:hidden">
      <NuxtLink to="/">
        <img
          class="block h-5 w-auto"
          src="/assets/icons/layout/logo-white.png"
          alt="Benchmark Mineral Intelligence"
        />
      </NuxtLink>
    </div>

    <div class="flex w-auto items-center justify-end gap-x-4 lg:gap-x-3">
      <DesktopMainNav :navigation="navigation" />
      <UserMenu />
    </div>
  </div>
</template>

<script setup lang="ts">
import UserMenu from '~/components/layout/UserMenu.vue'
import DesktopMainNav from '~/components/layout/DesktopMainNav.vue'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import type { TTopbarNavigationItem } from '~/src/types/navigation'

defineProps<{
  navigation: TTopbarNavigationItem[]
}>()

defineEmits(['openSidebar'])
</script>
